import { memo } from "react"
import { useArticleListConfiguration } from "../../ArticleListConfiguration"
import { useListParamsContext } from "../../ContextProvider"
import { usePartsAlternativesModuleState } from "../../PartsAlternatives/PartsAlternativesModuleState"
import { isCrossSellingEnabledForList } from "./helpers"
import { CrossSellingProps } from "./models"
import { CrossSellingComponent } from "./components/CrossSellingComponent"

export const CrossSelling = memo(
    ({ newSearchLoaded, crossSellingModalType, sortChanged, articlesCount, frontEndFilterChanged }: CrossSellingProps) => {
        const enableCrossSelling = useArticleListConfiguration((x) => x.enableCrossSelling)

        const isAlternativeSearch = usePartsAlternativesModuleState((x) => !!x)
        const listType = useListParamsContext((x) => x.listType)

        const displayCrossSelling = isCrossSellingEnabledForList(listType, isAlternativeSearch, crossSellingModalType)

        if (!enableCrossSelling || !displayCrossSelling) {
            return null
        }

        return (
            <CrossSellingComponent
                sortChanged={sortChanged}
                listType={listType}
                newSearchLoaded={newSearchLoaded}
                isAlternativeSearch={isAlternativeSearch}
                crossSellingModalType={crossSellingModalType}
                articlesCount={articlesCount}
                frontEndFilterChanged={frontEndFilterChanged}
            />
        )
    }
)
